import type { CatalogEntry } from '../schema/catalog';

const f = (slug: string, name: string, sell: number, set: string, part: 'single' | 'skull' | 'torso' | 'tail' | 'wing', silhouette: string, hallOrder: number) =>
  ({ id: `fossil.${slug}`, kind: 'fossil', name: `fossils.${name}`, sell, stack: 1, set, part, silhouette, hallOrder }) as const;

export default [
  f('unknown', 'unknown', 0, '', 'single', 'blob', 0),
  // Multi-part sets (assemble on one plinth in the fossil hall)
  f('trike_skull', 'trikeSkull', 5500, 'trike', 'skull', 'skull_horned', 1),
  f('trike_torso', 'trikeTorso', 5000, 'trike', 'torso', 'torso_ribs', 2),
  f('trike_tail', 'trikeTail', 4500, 'trike', 'tail', 'tail_long', 3),
  f('rex_skull', 'rexSkull', 6000, 'rex', 'skull', 'skull_rex', 4),
  f('rex_torso', 'rexTorso', 5500, 'rex', 'torso', 'torso_ribs', 5),
  f('rex_tail', 'rexTail', 5000, 'rex', 'tail', 'tail_long', 6),
  f('stego_skull', 'stegoSkull', 5000, 'stego', 'skull', 'skull_plated', 7),
  f('stego_torso', 'stegoTorso', 4500, 'stego', 'torso', 'torso_plates', 8),
  f('stego_tail', 'stegoTail', 4000, 'stego', 'tail', 'tail_spiked', 9),
  f('ptera_skull', 'pteraSkull', 4500, 'ptera', 'skull', 'skull_crest', 10),
  f('ptera_wing', 'pteraWing', 4500, 'ptera', 'wing', 'wing', 11),
  f('mammoth_skull', 'mammothSkull', 4000, 'mammoth', 'skull', 'skull_tusk', 12),
  f('mammoth_torso', 'mammothTorso', 3500, 'mammoth', 'torso', 'torso_ribs', 13),
  // Single fossils (wall plaques)
  f('ammonite', 'ammonite', 1100, 'ammonite', 'single', 'spiral', 14),
  f('trilobite', 'trilobite', 1300, 'trilobite', 'single', 'trilobite', 15),
  f('amber', 'amber', 1200, 'amber', 'single', 'amber', 16),
  f('dino_egg', 'dinoEgg', 1000, 'dino_egg', 'single', 'egg', 17),
  f('dino_track', 'dinoTrack', 1000, 'dino_track', 'single', 'footprint', 18),
  f('coprolite', 'coprolite', 1100, 'coprolite', 'single', 'coprolite', 19),
  f('shark_tooth', 'sharkTooth', 1000, 'shark_tooth', 'single', 'tooth', 20),
  f('sabertooth_skull', 'sabertoothSkull', 2500, 'sabertooth_skull', 'single', 'skull_saber', 21),
  f('archaeopteryx', 'archaeopteryx', 3000, 'archaeopteryx', 'single', 'bird', 22),
  f('dunkleosteus', 'dunkleosteus', 2500, 'dunkleosteus', 'single', 'fishbone', 23),
  f('eurypterid', 'eurypterid', 2000, 'eurypterid', 'single', 'scorpion', 24),
  f('fern', 'fern', 900, 'fern', 'single', 'fern', 25),
] as const satisfies readonly CatalogEntry[];
